<template>
  <div class="box">
    <el-page-header
      @back="$router.go(-1)"
      :content="$route.query.isEdit == 1 ? '修改题目' : '题目详情'"
    >
    </el-page-header>
    <div class="top-row">
      <h3 class="type">{{ checkType(questionInfo.type) }}</h3>
      <el-button
        class="btn"
        type="primary"
        size="small"
        v-show="$route.query.isEdit == 1"
        @click="handleEdit"
        >确定修改</el-button
      >
    </div>
    <div style="margin-left: 30px; margin-bottom: 20px">
      <span style="margin-right: 12px">章节</span>
      <el-cascader
        v-model="questionInfo.chapterId"
        :options="chapters"
        :props="{
          label: 'title',
          value: 'chapterId',
          emitPath: false,
        }"
        :show-all-levels="false"
        placeholder="请选择章节"
        clearable
        size="small"
        :disabled="$route.query.isEdit == 0"
      ></el-cascader>
      <!-- <el-select
        v-model="questionInfo.chapterId"
        placeholder="请选择章节"
        clearable
        size="small"
        :disabled="$route.query.isEdit == 0"
      >
        <el-option-group
          v-for="group in chapters"
          :key="group.chapterId"
          :label="group.title"
        >
          <el-option
            v-for="item in group.children"
            :key="item.chapterId"
            :label="item.title"
            :value="item.chapterId"
          >
          </el-option>
        </el-option-group>
      </el-select> -->
    </div>

    <component
      :is="questionInfo.type"
      :form="questionInfo"
      :noScore="true"
      :isEdit="$route.query.isEdit == 1"
    />
  </div>
</template>

<script>
import RADIO from "@/components/questionTemplate/radio";
import CHECKBOX from "@/components/questionTemplate/checkbox";
import BOOLEAN from "@/components/questionTemplate/boolean";
import SUPPLY from "@/components/questionTemplate/supply";
import ANSWER from "@/components/questionTemplate/answer";
import { checkType, handleTree } from "@/utils/index";
import { getInfo, editQuestion } from "@/api/questionBank";
import { chapterList } from "@/api/chapter";

export default {
  components: {
    RADIO,
    CHECKBOX,
    BOOLEAN,
    SUPPLY,
    ANSWER,
  },
  data() {
    return {
      checkType,
      questionInfo: {},
      chapters: [],
    };
  },
  created() {
    this.getChapterList();
    this.getQuestionInfo();
  },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.chapters = handleTree(res.data, "chapterId");
        } else {
          console.log(res.msg);
        }
      });
    },
    // 题目信息
    getQuestionInfo() {
      this.$loading.show();
      getInfo(this.$route.query.questionId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.questionInfo = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 提交修改
    handleEdit() {
      if (!this.checkQuestion(this.questionInfo)) return;
      this.$loading.show();
      editQuestion(this.questionInfo).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("修改成功");
          this.getQuestionInfo();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 空验证
    checkQuestion(question) {
      if (!question.question) {
        this.$message.error("题干不能为空");
        return false;
      } else if (question.type != "ANSWER") {
        if (question.answerList.length <= 0 || !question.answerList[0]) {
          this.$message.error("答案不能为空");
          return false;
        }
      }
      if (question.type == "RADIO" || question.type == "CHECKBOX") {
        if (
          question.optionList.some((item) => {
            return item.option == "";
          })
        ) {
          this.$message.error("选项不能为空");
          return false;
        }
      } else if (question.type == "SUPPLY") {
        if (
          question.answerList.some((item) => {
            return item == "";
          })
        ) {
          this.$message.error("答案不能为空");
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  padding: 20px 33px;
  text-align: left;
  background-color: #fff;
  ::v-deep .el-page-header {
    .el-page-header__content {
      font-size: 16px;
    }
  }
  .top-row {
    margin: 10px 0;
    line-height: 32px;
    overflow: hidden;
    .type {
      float: left;
    }
    .btn {
      float: right;
    }
  }
}
</style>